<div class="page" style="display: grid">
  <div class="page_header header">
    <a href="javascript:history.back(-1); void('');" class="container-arrow-left mr-2 " style="max-width: 250px">
      <img src="assets/svg/arrow-left.svg" alt="">
    </a>
    <h1 class="page_title title">Tarefas <span>Ações</span></h1>
  </div>

  <div class="wrapper todo">
    <form [formGroup]="tasksForm" (ngSubmit)="onSubmit()" class="content">
      <div class="add-todo">
        <div>
          <label for="description">Adicione uma tarefa</label>
          <input type="text" id="description" placeholder="Digite aqui" maxlength="255" formControlName="taskDescription">
        </div>

        <button type="submit" [disabled]="tasksForm.invalid">
          <img src="assets/svg/verify.svg" alt="">
        </button>
      </div>

      <div class="tasks">
        <p>Tarefas Adicionadas</p>

        <div class="task" *ngFor="let task of tasks; let i = index">
          <input type="checkbox" [checked]="task.status" (change)="updateTaskStatus(task?.id)"/>
          <input type="text" [value]="task.description" readonly>
          <button (click)="removeActionTask(i, task.id)">
            <img src="assets/svg/drash.svg" alt="">
          </button>
        </div>

        <p *ngIf="!tasks?.length">Nenhuma tarefa encontrada</p>
      </div>
    </form>
  </div>
</div>